import { CommonDTO } from './../model/common-dto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { UrlConfigService } from './url-config.service';

@Injectable({
  providedIn: 'root',
})
export class AuditItemLogService {
  //url = environment.SERVER_URL;
  url: string;

  constructor(private http: HttpClient, private urlConfigService: UrlConfigService) {
    this.url = this.urlConfigService.apiServerUrl;
  }

  getAuditItemsLogList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}audit-program/audit-item-log`, commonDTO);
  }
}
